import { useEffect } from "react";
import { Navigation } from "../../components/Navigation/navigation";
import { KeyFeatures } from "../../components/KeyFeatures/KeyFeatures";
import './foundations.css';
export const Foundations = ( props ) => {
    useEffect(()=>{
        document.querySelector("body#ruby-rock-app").scrollTop = 0;
    },[])
    return (
        <>
        <Navigation />
        <div id="foundations" className='text-center'>
            <div className='container'>
                <div className='section-title'>

                    <KeyFeatures />
                    
                    <h2>Three Key Foundations</h2>
                    <p>RubyRock is built on three key foundations:</p>
                    
                    <div className='row foundations'>
                        <h3>1. Real Asset:</h3>
                        <ol>
                            <li>A Ruby Specimen: Natural Corundum Ruby in Zoisite Matrix – GIA certified (Gemological Institute of America).</li>
                            <li>Extracted from a ruby mine in Arusha region in north-eastern Tanzania.</li>
                            <li>32,700 carats; 6.54-kilogram.</li>
                            <li>Appraisal value $261,600,000.</li>
                        </ol>
                        <h3>2. DeFi:</h3>
                        <ol>
                            <li>Rewards Pool: 50% of every secondary market transaction fee is destined to a community vault to be distributed quarterly to holders of RubyRock.</li>
                            <li>Staking options: Staking will be available through the various phases of the project.</li>
                            <li>P2P Exchanges:  RubyRock is a digital asset that can be easily and securely transferred anywhere at any time as a trustworthy medium of exchange.</li>
                        </ol>
                        <h3>3. Art Work:</h3>
                        <ol>
                            <li>A collection of 83 hand-drawn artistic layers with different designs and colors representing the ruby stone Specimen and the source of the Specimen, Tanzania.</li>
                            <li>Selected emerging artists from different regions around the world will create artworks with unique marks, while growing the RubyRock family through their organic communities.</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}